import { oc } from "@orpc/contract";
import { EmailSignatureSchema } from "./user-preferences.contract";

/**
 * Saving the signature is more than a preference write: it reconciles the
 * signature's images against blob storage, deleting any signature image the
 * user no longer references (replaced or uploaded-then-removed). That cleanup
 * is signature-specific, so it lives behind a dedicated procedure rather than
 * the generic `userPreferences.upsert`. Reads still go through
 * `userPreferences.get('emailSignature')`.
 */
export const emailSignatureContracts = {
  save: oc
    .input(EmailSignatureSchema)
    .output(EmailSignatureSchema)
    .route({ method: "POST" }),
} as const;
